import { render, staticRenderFns } from "./WelcomeKits.vue?vue&type=template&id=0925d0bd&"
import script from "./WelcomeKits.vue?vue&type=script&lang=js&"
export * from "./WelcomeKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports